/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MemberCategories } from '../../models/member-categories';
import { MemberCategoriesCreate } from '../../models/member-categories-create';

export interface CreateMemberCategoryInternalV2MembersCategoriesPost$Params {
  org: string;
      body: MemberCategoriesCreate
}

export function createMemberCategoryInternalV2MembersCategoriesPost(http: HttpClient, rootUrl: string, params: CreateMemberCategoryInternalV2MembersCategoriesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MemberCategories>> {
  const rb = new RequestBuilder(rootUrl, createMemberCategoryInternalV2MembersCategoriesPost.PATH, 'post');
  if (params) {
    rb.query('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MemberCategories>;
    })
  );
}

createMemberCategoryInternalV2MembersCategoriesPost.PATH = '/_internal/v2/members/categories';
